export  default {
    getUsage(state) {
        return state.usage;
    },

};